import { useEffect, useState } from 'react';
import { Smartphone, Download, WifiOff, CheckCircle2, Share } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { ErpHeading } from '../../components/erp/ErpShared';
import '../../components/erp/assets.css';

export default function MobilePage() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [online, setOnline] = useState(navigator.onLine);
  const [swReady, setSwReady] = useState(false);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const onPrompt = e => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    const on = () => setOnline(true); const off = () => setOnline(false);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    if (window.matchMedia('(display-mode: standalone)').matches) setInstalled(true);
    if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistration().then(r => setSwReady(!!r));
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled); window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  const install = async () => { if (!deferred) return; deferred.prompt(); await deferred.userChoice; setDeferred(null); };

  const Card = ({ icon: Icon, title, children, accent }) => <div className="border border-white/5 rounded-xl p-5">
    <div className="flex items-center gap-2 mb-2"><Icon className="w-5 h-5" style={{ color: accent }} /><p className="font-semibold text-sm">{title}</p></div>{children}</div>;

  return <div data-testid="mobile-page">
    <ErpHeading title="Aplicație mobilă (PWA)"><span className="text-xs text-muted-foreground flex items-center gap-1"><Smartphone className="w-4 h-4" />Instalare & lucru offline</span></ErpHeading>
    <p className="text-sm text-muted-foreground mb-5 max-w-2xl">Instalează SAGA Operațiuni pe telefon sau desktop pentru acces rapid, ecran complet și un shell care se încarcă și fără conexiune. Datele operaționale se sincronizează când ești online.</p>

    <div className="grid md:grid-cols-2 gap-5">
      <Card icon={Download} title="Instalează aplicația" accent="#3b82f6">
        {installed ? <p className="text-sm text-emerald-400 flex items-center gap-2" data-testid="pwa-installed"><CheckCircle2 className="w-4 h-4" />Aplicația este instalată.</p>
          : isIOS ? <p className="text-sm text-muted-foreground" data-testid="pwa-ios">Pe iPhone/iPad: apasă <Share className="w-4 h-4 inline" /> <strong>Distribuie</strong> → <strong>„Adaugă pe ecranul principal"</strong>.</p>
          : deferred ? <Button onClick={install} data-testid="pwa-install-btn"><Download className="w-4 h-4 mr-2" />Instalează acum</Button>
          : <p className="text-sm text-muted-foreground" data-testid="pwa-install-hint">Deschide din meniul browserului „Instalează aplicația" / „Adaugă pe ecranul principal". Butonul apare automat pe dispozitivele compatibile.</p>}
      </Card>
      <Card icon={online ? CheckCircle2 : WifiOff} title="Stare conexiune" accent={online ? '#10b981' : '#f43f5e'}>
        <p className="text-sm" data-testid="pwa-online-state">{online ? 'Online — date live.' : 'Offline — se afișează ultimul conținut memorat.'}</p>
        <p className="text-xs text-muted-foreground mt-1">Shell offline: {swReady ? 'activ' : 'se pregătește…'}</p>
      </Card>
    </div>

    <div className="mt-5 border border-white/5 rounded-xl p-5">
      <p className="font-semibold text-sm mb-2">Ce oferă modul PWA</p>
      <ul className="text-sm text-muted-foreground space-y-1 list-disc pl-5">
        <li>Instalare pe ecranul principal (iconiță și ecran complet, fără bara browserului).</li>
        <li>Încărcare rapidă și shell disponibil offline pentru navigare de bază.</li>
        <li>Optimizat pentru telefon — util pe șantier pentru jurnal, alocări și notificări.</li>
        <li>Datele sensibile (API) nu sunt memorate; se cer mereu live când ești conectat.</li>
      </ul>
    </div>
  </div>;
}
